import { isBefore, startOfDay, startOfWeek, endOfWeek, isWithinInterval } from "date-fns";
import { formatCurrency } from "../../../../utils/formatCurrency";
import { InvoiceSchedule } from "../types";

type ScheduledInvoiceItem = {
    quantity: number;
    price: number;
};

type Notifications = {
    setNotification: (config: { message: string; severity: "error" | "success" | "warning"; isOpen: boolean }) => void;
};

export const showError = (notifications: Notifications, message: string) => {
    notifications.setNotification({
        message,
        severity: "error",
        isOpen: true,
    });
};

export const validateScheduledDate = (date: Date | null, notifications: Notifications): boolean => {
    if (!date) {
        showError(notifications, "Por favor, selecione uma data");
        return false;
    }

    if (isBefore(startOfDay(date), startOfDay(new Date()))) {
        showError(notifications, "Não é possível agendar para uma data passada");
        return false;
    }

    return true;
};

const TOTAL_TOLERANCE = 0.01;

export const validateScheduledTotal = (
    invoicedTotal: number | null,
    pendingScheduledTotal: number,
    newItemsTotal: number,
    orderTotal: number,
    notifications: Notifications,
    scheduleCount: number = 1
): boolean => {
    if (invoicedTotal === null) {
        showError(notifications, "Os documentos de faturação ainda estão a carregar. Tente novamente.");
        return false;
    }

    const newScheduledTotal = pendingScheduledTotal + (newItemsTotal * scheduleCount);
    const projectedTotal = invoicedTotal + newScheduledTotal;

    if (projectedTotal > orderTotal + TOTAL_TOLERANCE) {
        const verb = scheduleCount > 1 ? "excederia" : "excede";
        showError(
            notifications,
            `O total faturado (${formatCurrency(invoicedTotal)}) mais o agendado (${formatCurrency(newScheduledTotal)}) ${verb} o total da compra (${formatCurrency(orderTotal)})`
        );
        return false;
    }

    return true;
};

export const validateCanDelete = (status: "scheduled" | "created", notifications: Notifications): boolean => {
    if (status === "created") {
        showError(notifications, "Não é possível eliminar um agendamento já criado");
        return false;
    }

    return true;
};

export const calculateItemsTotal = (items: Array<ScheduledInvoiceItem>): number => {
    return items.reduce((sum, item) => sum + (item.quantity * item.price), 0);
};

export const checkExistingSchedulesInWeek = (
    scheduledDate: Date,
    existingSchedules: Array<InvoiceSchedule>
): number => {
    const weekStart = startOfWeek(scheduledDate, { weekStartsOn: 1 });
    const weekEnd = endOfWeek(scheduledDate, { weekStartsOn: 1 });

    const schedulesInWeek = existingSchedules.filter((schedule) => {
        const scheduleDate = new Date(schedule.scheduled_date);
        const isInWeek = isWithinInterval(scheduleDate, { start: weekStart, end: weekEnd });
        return isInWeek;
    });

    const count = schedulesInWeek.length;
    return count;
};
